import { Spin } from "antd";
import style from "./PageSpin.module.scss";
import React from "react";

export default function PageSpin() {
    return <Spin className={style.root} />;
}
